import { APIMethod, fetchData } from "@client";

export const getS3PreSignedUrl = async ({
  fileName,
  contentType,
  expirationTime,
  deleteObjectAction,
  fileType,
}) => {
  const res = await fetchData(
    `/v1/upload/presigned-url${deleteObjectAction ? "-delete" : ""}`,
    APIMethod.GET,
    {
      params: {
        fileName,
        contentType,
        expirationTime,
        fileType,
      },
      mapRequestKeysToSnakeCase: false,
    }
  );

  return res.presignedUrl;
}